import { Button, TextField, Tooltip } from "@material-ui/core";
import { LocalOffer } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	changeStatusCustomer,
	deleteCustomer,
	getCustomers,
} from "../../../../api/customer";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, { buttonsStyle } from "../../../components/tables/table";
import CustomerContent from "./CustomerContent";
import { normalizeString } from "../../../../utils/helpers";

function getData(customers) {
	let data = [];
	for (let i = 0; i < customers.length; ++i) {
		const elem = {};
		const customer = customers[i];

		elem.nombre = customer?.nombre;
		elem.razonSocial = customer?.razon_social;
		elem.poblacion = customer?.poblacion;
		elem.provincia = customer?.provincia;
		elem.activo = customer?.activo;
		elem.id = customer?.id;

		data = data.concat(elem);
	}
	return data;
}

const initialFilters = {
	provincia: "",
	poblacion: "",
};

export default function CustomersPage() {
	const [data, setData] = useState([]);
	const [selectedCustomer, setSelectedCustomer] = useState(null);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openCustomerInfoDialog, setOpenCustomerInfoDialog] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const [filteredData, setFilteredData] = useState([]);
	const [collapsed, setCollapsed] = useState(true);
	const [filterOptions, setFilterOptions] = useState(initialFilters);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							history.push("/clientes/" + cell + "/edit");
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Ver ofertas">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
						}}
					>
						<LocalOffer />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip
							title={elem?.activo ? "Desactivar" : "Activar"}
						>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedCustomer(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.activo ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedCustomer(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	function getTowns() {
		let uniqueTowns = Array.from(
			new Set(
				data?.map((x) => x.poblacion && normalizeString(x.poblacion))
			)
		);

		return uniqueTowns;
	}

	function getProvinces() {
		let uniqueProvinces = Array.from(
			new Set(
				data?.map((x) => x.provincia && normalizeString(x.provincia))
			)
		);

		return uniqueProvinces;
	}

	const columns = [
		{ dataField: "nombre", text: "Nombre Comercial", sort: true },
		{
			dataField: "razonSocial",
			text: "Razón Social",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "poblacion",
			text: "Población",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "provincia",
			text: "Provincia",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getCustomers(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setFilteredData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener los clientes.",
				});
			});
	}, [refresh]);

	const handleSearch = async () => {
		if (!data.length) return;
		setFilteredData(
			data.filter((item) => {
				let filter = true;
				if (filterOptions.poblacion)
					filter =
						filter &&
						normalizeString(filterOptions.poblacion) ===
							normalizeString(item?.poblacion);
				if (filterOptions.provincia)
					filter =
						filter &&
						normalizeString(filterOptions.provincia) ===
							normalizeString(item?.provincia);
				if (filter) return item;
				return false;
			})
		);
	};

	const handleClearFilters = () => {
		setFilterOptions(initialFilters);
		setRefresh(true);
	};

	const renderFiltersContent = () => {
		return (
			<>
				<div className="d-sm-flex w-100">
					<Autocomplete
						className="w-100 mr-5"
						id="autocomplete-poblacion"
						filterSelectedOptions
						options={getTowns()}
						getOptionLabel={(option) => option}
						value={filterOptions.poblacion || ""}
						onChange={(event, selected) => {
							setFilterOptions({
								...filterOptions,
								poblacion: selected,
							});
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								margin="normal"
								variant="outlined"
								InputLabelProps={{
									shrink: true,
								}}
								label="Población"
							/>
						)}
					/>
					<Autocomplete
						className="w-100 mr-5"
						id="autocomplete-provincia"
						filterSelectedOptions
						options={getProvinces()}
						getOptionLabel={(option) => option}
						value={filterOptions.provincia || ""}
						onChange={(event, selected) => {
							setFilterOptions({
								...filterOptions,
								provincia: selected,
							});
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								margin="normal"
								variant="outlined"
								InputLabelProps={{
									shrink: true,
								}}
								label="Provincia"
							/>
						)}
					/>
				</div>
			</>
		);
	};

	return (
		<>
			<Card>
				<CardHeader headerClassName="px-0">
					<CardHeader
						title="Clientes"
						sticky={false}
						headerClassName="d-flex justify-content-between w-100 py-3"
					>
						<CardHeaderToolbar>
							<button
								type="button"
								className="btn btn-primary"
								onClick={() => history.push("/clientes/edit")}
							>
								Nuevo cliente
							</button>
						</CardHeaderToolbar>
					</CardHeader>
					<div className="w-100">
						<FiltersCard
							collapsable={false}
							filtersContent={renderFiltersContent}
							collapsed={collapsed}
							setCollapsed={setCollapsed}
							handleClearFilters={handleClearFilters}
							handleSearch={handleSearch}
						/>
					</div>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(filteredData)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const customer = data?.find(
									(x) => x.id === row.id
								);
								setSelectedCustomer(customer);
								setOpenCustomerInfoDialog(true);
							},
						}}
					/>

					<ConfirmDialog
						title={`¿Estás seguro de que quieres ${
							selectedCustomer?.activo ? "desactivar" : "activar"
						} este cliente?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusCustomer(
								selectedCustomer.id,
								!selectedCustomer?.activo,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: `${
												selectedCustomer?.activo
													? "¡Desactivado!"
													: "¡Activado!"
											}`,
											customMessage: `Cliente ${
												selectedCustomer?.activo
													? "desactivado"
													: "activado"
											} con éxito`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `No se ha podido ${
											selectedCustomer?.activo
												? "desactivar"
												: "activar"
										} el cliente.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar este cliente?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteCustomer(
								selectedCustomer?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminado!",
											customMessage:
												"Cliente eliminado con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar el cliente.",
									});
								});
						}}
					/>
					<EntityInfoDialog
						title={"Cliente: " + selectedCustomer?.nombre}
						open={openCustomerInfoDialog}
						setOpen={setOpenCustomerInfoDialog}
						content={
							<CustomerContent customer={selectedCustomer} />
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
